export class RotationOrderProductDate {

    id: number | null;
    orderDay: number;
    orderMonth: number;
    productShortName: string;


    constructor(orderDay: number, orderMonth: number, productShortName: string) {
        this.id = null;
        this.orderDay = orderDay;
        this.orderMonth = orderMonth;
        this.productShortName = productShortName;
    }
}
